import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

export type SwitchSize = 'md' | 'sm';

/**
 * Kciuk trzyma 3 px marginesu przezroczystą ramką toru, więc przesunięcie to
 * szerokość toru minus ramki i minus sam kciuk.
 */
const trackSizeClass: Record<SwitchSize, string> = {
  md: 'h-[26px] w-11',
  sm: 'h-[22px] w-[38px]',
};

const thumbSizeClass: Record<SwitchSize, string> = {
  md: 'size-5 data-[state=checked]:translate-x-[18px]',
  sm: 'size-4 data-[state=checked]:translate-x-4',
};

/**
 * Przełącznik dwustanowy. Barwy są z palety aplikacji, a nie z tokenów shadcn
 * (`primary`, `input`) — te są w `tailwind.config.ts` oznaczone jako przejściowe
 * i nasze komponenty mają ich nie używać.
 */
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    size?: SwitchSize;
  }
>(({ className, size = 'md', ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-[3px] border-transparent transition-colors duration-150',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-60',
      'data-[state=checked]:bg-accent-600 data-[state=unchecked]:bg-neutral-200',
      trackSizeClass[size],
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block rounded-full bg-basic-white shadow-[0_1px_2px_rgba(18,20,26,0.2)] transition-transform duration-150 data-[state=unchecked]:translate-x-0',
        thumbSizeClass[size],
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
